<template>
  <div class="element-popup" v-if="status.popup">
    <div class="container">
    <div class="popup-header">
      자동차 모델
      <!--{{ label }}-->
      <div class="close" @click="clickClose()">

      </div>
    </div>

    <div class="popup-body" id="car-chooser">


      <div class="result">
        <div class="return-prev" @click="step > 1 ? step-- : null">
          <div>
            <i class="fa fa-angle-left"></i>이전
          </div>
        </div>
        <div class="result-text">
          <div>
            {{step_choose.company}}
            <template v-if="step_choose.carname">
              <span>></span>{{step_choose.carname}}
            </template>
            <template v-if="step_choose.year">
              <span>></span>{{step_choose.year}}
            </template>
            <template v-if="step_choose.carnamesdetail">
              <span>></span>{{step_choose.carnamesdetail}}
            </template>
            <template v-if="step_choose.caroptions">
              <span>></span>{{step_choose.caroptions}}
            </template>
          </div>
        </div>
      </div>
      <div class="select">

        <div class="inner" v-bind:style="{ width: ( windowWidth > 1000 ? 1000 : windowWidth ) / 2 * 7 + 'px', left : ( windowWidth > 1000 ? 1000 : windowWidth ) / 2 * ( step - 1 ) * -1 + 'px' }">

          <div class="step" v-bind:style="{ width: ( windowWidth > 1000 ? 1000 : windowWidth ) / 2 + 'px' }">
            <div class="title">1.제조사</div>
            <div class="items">
              <ul>
                <li v-for="(item, index) in steps_data.companys" @click='clickStep( 1, item.value );' v-bind:class="{ current : ( step_choose.company == item.value ) }">{{item.value}}</li>
              </ul>
            </div>
          </div>

          <div class="step" v-bind:style="{ width: ( windowWidth > 1000 ? 1000 : windowWidth ) / 2 + 'px' }">
            <div class="title">2.차명</div>
            <div class="items">
              <div v-if="steps_data.carnames.length  == 0" class="step-empty">
                제조사를 선택해주세요
              </div>
              <ul>
                <li v-for="(item, index) in steps_data.carnames" @click='clickStep( 2, item.value );' v-bind:class="{ current : ( step_choose.carname == item.value ) }">{{item.value}}</li>
              </ul>
            </div>
          </div>

          <div class="step" v-bind:style="{ width: ( windowWidth > 1000 ? 1000 : windowWidth ) / 2 + 'px' }">
            <div class="title">3.등록연도</div>
            <div class="items">
            <ul>
              <li v-for="(item, index) in steps_data.years" @click='clickStep( 3, item.value );'
               v-bind:class="{ current : ( step_choose.year == item.value ) }">
                <template v-if="item.sub">
                  {{item.value}}<br>{{item.sub}}
                </template>
                <template v-else>
                  {{item.value}}
                </template>

              </li>
            </ul>
            </div>
          </div>

          <div class="step" v-bind:style="{ width: ( windowWidth > 1000 ? 1000 : windowWidth ) / 2 + 'px' }">
            <div class="title">4.세부차명</div>
            <div class="items">
              <div v-if="steps_data.carnamesdetail.length  == 0" class="step-empty">
                제조사를 선택해주세요
              </div>
              <ul>
                <li v-for="(item, index) in steps_data.carnamesdetail" @click='clickStep( 4, item.value );' v-bind:class="{ current : ( step_choose.carnamesdetail == item.value ) }">{{item.value}}</li>
              </ul>
            </div>
          </div>

          <div class="step" v-bind:style="{ width: ( windowWidth > 1000 ? 1000 : windowWidth )  + 'px' }">
            <div class="title">5.세부옵션<span class="sub-tit">차량가액</span></div>
            <div class="items">

              <div v-if="steps_data.caroptions.length  == 0" class="step-empty">
                제조사를 선택해주세요
              </div>
              <ul>
                <li v-for="(item, index) in steps_data.caroptions"
                @click='clickStep( 5, item )'
                :class="{ current : ( step_choose.caroptions == item.value ) }">
                  <div>{{item.value}}</div>
                  <span><span>{{item.price}}</span>만원</span>
                </li>
              </ul>

            </div>
          </div>



        </div>

      </div>

      <!--
      1
      <div class="section-radio">
        <div class="container">
          <element-content-radio @checkValue="checkValue" :subLabel="subLabel" :error="data.error" :label="data.label" :autoName="auto" :items="searchList" />
        </div>
      </div>

      <div class="section-tab">
        <div class="container">
          <div class="section-tab-header">
            <element-tab>
              <element-tab-item @click="popupTab = '상세설명'" :on="popupTab == '상세설명'">상세설명</element-tab-item>
              <element-tab-item @click="popupTab = '질문하기'" :on="popupTab == '질문하기'">질문하기</element-tab-item>
            </element-tab>
          </div>
        </div>

        <div class="body-item" v-if="popupTab == '상세설명'">
          <div class="container">
            <div v-for="item in description">
              {{ item.value }}
            </div>
          </div>
        </div>


        <div class="body-item" v-if="popupTab == '질문하기'">
          <div class="container">
            <template id="tab-question">
              <label>{{ question.label }}</label>
              <element-textarea v-model="question.content.value" :error="question.content.error" :placeholder="question.content.placeholder" />
              <element-textbox v-model="question.phone.value" :error="question.phone.error" :placeholder="question.phone.placeholder" />
              <element-textbox v-model="question.email.value" :error="question.email.error" :placeholder="question.email.placeholder" />
              <button @click="submitQuestion">보내기</button>
              <element-confirm />
            </template>
          </div>
        </div>
      </div>
      -->
    </div>

    <div class="popup-bottom">
      <button @click="clickClose()" class="cancel">취소</button>
      <button @click="clickComplete()" class="confirm" :class="{disabled : nextbtn_text != '확인' }">{{nextbtn_text}}</button>
    </div>
    <slot />
  </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  props: [ "value", "data", "description", "type", "statusPopup", "list", "label", "auto", "subLabel", "insur_startdate"],
  data(){
    return {
      event_cst: null,
      nextbtn_text: "제조사를 선택해주세요",
      windowWidth : 0,
      status: this.statusPopup,
      popupTab: '상세설명',

      step : 1,
      steps_data : {
        companys : [{"value":"현대","label":"현대","ov":1},{"value":"기아","label":"기아","ov":2},{"value":"쌍용","label":"쌍용","ov":3},{"value":"GM대우","label":"GM대우","ov":4},{"value":"르노삼성","label":"르노삼성","ov":5},{"value":"외제차","label":"외제차","ov":6}],
        carnames : [],
        years : [],
        carnamesdetail : [],
        caroptions : [],
        carvalue: []
      },

      step_choose : {
        id: '',
        company : '',
        carname : '',
        year : '',
        carnamesdetail: '',
        caroptions : '',
        price: ''
      },

      searchList: [],

      question: {
        label: "질문하기",
        content: {
          value: "",
          error: "",
          placeholder: "특별히 보장 받고 싶은 보장 항목, 기간, 금액 또는 현재 가입 중인 보험 그리고 상담 전 남기실 말씀을 입력하십시오. (200자 이내)",
        },
        phone: {
          value: "",
          error: "",
          placeholder: "답변 받을 휴대폰 번호"
        },
        email: {
          value: "",
          error: "",
          placeholder: "답변 받을 이메일 주소",
        }
      },
      api_prm_year: null,
      api_prm_quarter: null
    }
  },
  mounted() {
    // window.dispatchEvent(new Event("resize"));
    var _ths = this;
    if(document.querySelector('.element-popup')) _ths.windowWidth = document.querySelector('.element-popup').clientWidth;
  },
  beforeCreate (){

  },
  updated() {
    var _ths = this;
    if(document.querySelector('.element-popup')) _ths.windowWidth = document.querySelector('.element-popup').clientWidth;
  },
  created() {
    var _ths = this;
    if(document.querySelector('.element-popup')) _ths.windowWidth = document.querySelector('.element-popup').clientWidth;
    this.$store.commit( "SET_DIMMER", true );
    /* 등록연도 재설정 */
    //insur_startdate : 27

    this.api_prm_year = moment(this.insur_startdate).year()
    this.api_prm_quarter = moment(this.insur_startdate).quarter()
    this.steps_data.years = []

    /*
    var ins_range_date = moment(this.insur_startdate).subtract(6, 'month');
    var ins_range_date_year = ins_range_date.year();

    for(var i = moment().year(); i >= moment().year() - 27; i--){
      if(ins_range_date_year == i){
        this.steps_data.years.push(
          { value: i + "A", label: i + "A", sub: ins_range_date.format("MM월DD일 이후") }
        )
        this.steps_data.years.push(
          { value: i + "B", label: i + "B", sub: ins_range_date.subtract(1,'days').format("MM월DD일 이후") }
        )
      }else{
        this.steps_data.years.push(
          { value: i, label: i }
        )
      }
    }
    */

    this.searchList = this.data.items[this.status.index].options;

    if(typeof(Event) === 'function') {
      window.addEventListener('resize', function(){
        if(document.querySelector('.element-popup')) _ths.windowWidth = document.querySelector('.element-popup').clientWidth;
      });
    }else{
      this.event_cst = document.createEvent('Event');
      this.event_cst.initEvent('resize', true, true);
    }



    if(this.data.value) this.step_choose = JSON.parse(JSON.stringify(this.data.value))

    var params = {
      search_auto_type: this.type,
      search_step: 0,
      search_table_year: this.api_prm_year,
      search_table_quarter: this.api_prm_quarter,
    }
    this.$store.dispatch( "estimate/getAutoFiltered", params ).then( res => {
      var tmp_ord = [{label: "현대", ov: 1},{label: "기아", ov: 2},{label: "쌍용", ov: 3},{label: "GM대우", ov: 4},{label: "르노삼성", ov: 5},{label: "외제차", ov: 6}]
      this.steps_data.companys = []
      res.data.data.list.forEach( o => {
        this.steps_data.companys.push( { value: o.제조사, label: o.제조사, ov: tmp_ord.find(i => i.label == o.제조사).ov } )
      })
      // ov 기준으로 정렬
      this.steps_data.companys.sort(function (a, b) {
        if (a.ov > b.ov) {
          return 1;
        }
        if (a.ov < b.ov) {
          return -1;
        }
        return 0;
      });
    })
    if(this.status.index >= 0 && this.data.value.company){
      this.step = this.status.index + 1
      var params = {
        search_auto_type: this.type,
        search_auto_company: this.data.items[0].subLabel,
        search_step: 1,
        search_table_year: this.api_prm_year,
        search_table_quarter: this.api_prm_quarter,
      }
      this.$store.dispatch( "estimate/getAutoFiltered", params ).then( res => {
        this.steps_data.carnames = [];
        res.data.data.list.forEach( o => {
          this.steps_data.carnames.push( { value: o.공통차명, label: o.공통차명 } )
        })

      })
    }

    if(this.status.index >= 2 && this.data.value.year && this.data.value.carname){
      this.step = this.status.index + 1
      var params = {
        search_auto_company: this.data.items[0].subLabel,
        search_auto_type: this.type,
        search_auto_name: this.data.items[1].subLabel,
        // search_name: this.data.items[3].subLabel,
        search_registe_date: this.data.items[2].subLabel,
        search_detail: this.data.items[3].subLabel,
        // search_text: this.data.items[1].subLabel,
        search_step: this.status.index,
        search_table_year: this.api_prm_year,
        search_table_quarter: this.api_prm_quarter,
      }
      this.$store.dispatch( "estimate/getAutoFiltered", params ).then( res => {
        this.steps_data.carnamesdetail = [];
        res.data.data.list.forEach( o => {
          this.steps_data.carnamesdetail.push( { value: o.차명, label: o.차명 } )
        })
      })

    }
    if(this.status.index >= 3 && this.data.value.carnamesdetail && this.data.value.year && this.data.value.carname) {
      this.step = this.status.index + 1
      var params = {
        search_auto_company: this.data.items[0].subLabel,
        search_auto_type: this.type,
        search_auto_name: this.data.items[1].subLabel,
        // search_name: this.data.items[3].subLabel,
        search_registe_date: this.data.items[2].subLabel,
        search_detail: this.data.items[3].subLabel,
        // search_text: this.data.items[1].subLabel,
        search_step: 4,
        search_table_year: this.api_prm_year,
        search_table_quarter: this.api_prm_quarter,
      }
      this.$store.dispatch( "estimate/getAutoFiltered", params ).then( res => {

        this.steps_data.caroptions = [];
        res.data.data.list.forEach( o => {
          this.steps_data.caroptions.push( { value: o.세분, label: o.세분, price: o[params.search_registe_date], carcode: o.차명코드 } );
        })
      });
    }
  },
  destroyed() {
    if(typeof(Event) === 'function') {
      window.dispatchEvent(new Event("resize"));
    }else{
      window.dispatchEvent(this.event_cst);
    }

  },
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  methods: {

    clickStep( idx, value, car_price ){

      if( idx == 1 )
      {
        this.nextbtn_text = "차명을 선택해주세요"
        this.step_choose.company = value;
        this.step_choose.carname = ''
        this.step_choose.year = ''
        this.step_choose.carnamesdetail = ''
        this.step_choose.caroptions = ''
        this.step_choose.price = ''

        var params = {
          search_auto_type: this.type,
          search_auto_company: this.step_choose.company,
          search_step: 1,
          search_table_year: this.api_prm_year,
          search_table_quarter: this.api_prm_quarter,
        }

        this.$store.dispatch( "estimate/getAutoFiltered", params ).then( res => {
          this.searchList = [];
          this.steps_data.carnames = [];
          res.data.data.list.forEach( o => {

            this.steps_data.carnames.push( { value: o.공통차명, label: o.공통차명 } )
          })

        })
      }else if ( idx == 2 ) {
        this.nextbtn_text = "등록년도를 선택해주세요"
        // 차명 클릭햇을때
        this.step = 2;
        this.step_choose.carname = value;
        this.step_choose.year = ''
        this.step_choose.carnamesdetail = ''
        this.step_choose.caroptions = ''
        this.step_choose.price = ''

        var params = {
          search_auto_company: this.step_choose.company,
          search_auto_type: this.type,
          search_auto_name: this.step_choose.carname,
          search_step: 2,
          search_table_year: this.api_prm_year,
          search_table_quarter: this.api_prm_quarter,
        }

        var ins_range_date = moment(this.insur_startdate).subtract(6, 'month');
        var ins_range_date_year = ins_range_date.year();

        this.$store.dispatch( "estimate/getAutoFiltered", params ).then( res => {
          this.steps_data.carnamesdetail = [];
          this.steps_data.years = []

          if(res.data.data.list.length > 0){
            Object.keys(res.data.data.list[0]).forEach(o => { // sort((a, b) => a - b).reverse().

              if(res.data.data.list[0][o] > 0) {
                if(o.indexOf(ins_range_date_year) >= 0 && o.indexOf("A") >= 0){
                  this.steps_data.years.push(
                    { value: o, label: o, sub: moment(ins_range_date).format("MM월DD일 이후"), sort: Number(String(o).substring(0,4)) + 0.1 }
                  )
                }else if(o.indexOf(ins_range_date_year) >= 0 && o.indexOf("B") >= 0){
                  this.steps_data.years.push(
                    { value: o, label: o, sub: moment(ins_range_date).subtract(1,'days').format("MM월DD일 이전"), sort: Number(String(o).substring(0,4)) }
                  )
                }else{
                  this.steps_data.years.push({ value: o, label: o, sort: o })
                }

              }
            })
          }

          this.steps_data.years.sort(function (a,b) {
            if (a.sort > b.sort) {
              return 1;
            }
            if (a.sort < b.sort) {
              return -1;
            }
            return 0;
          }).reverse()
          // console.log("filtered", this.steps_data.years);

          //this.steps_data.carvalue = filtered;
        });
      }else if( idx == 3 ) {
        this.nextbtn_text = "세부차명을 선택해주세요"
        this.step = 3;
        this.step_choose.year = value;

        this.step_choose.carnamesdetail = ''
        this.step_choose.caroptions = ''
        this.step_choose.price = ''

        var params = {
          search_auto_company: this.step_choose.company,
          search_auto_type: this.type,
          search_auto_name: this.step_choose.carname,
          // search_name: this.data.items[3].subLabel,
          search_registe_date: this.step_choose.year,
          // search_detail: this.status.index == 3 ? '' : this.data.items[1].subLabel,
          // search_text: this.data.items[1].subLabel,
          search_step: 3,
          search_table_year: this.api_prm_year,
          search_table_quarter: this.api_prm_quarter,
        }
        this.$store.dispatch( "estimate/getAutoFiltered", params ).then( res => {

          this.steps_data.carnamesdetail = [];
          res.data.data.list.forEach( o => {
            this.steps_data.carnamesdetail.push( { value: o.차명, label: o.차명 } );
          })
        });
      }else if ( idx == 4 )
      {
        this.nextbtn_text = "세부옵션을 선택해주세요"
        this.step = 5;
        this.step_choose.carnamesdetail = value;
        this.step_choose.caroptions = ''
        this.step_choose.price = ''
        var params = {
          search_auto_company: this.step_choose.company,
          search_auto_type: this.type,
          search_auto_name: this.step_choose.carname,
          //search_name: this.step_choose.year,
          search_registe_date: this.step_choose.year,
          search_detail: this.step_choose.carnamesdetail,
          // search_text: this.data.items[1].subLabel,
          search_step: 4,
          search_table_year: this.api_prm_year,
          search_table_quarter: this.api_prm_quarter,
        }
        this.$store.dispatch( "estimate/getAutoFiltered", params ).then( res => {

          this.steps_data.caroptions = [];
          res.data.data.list.forEach( o => {
            this.steps_data.caroptions.push( { value: o.세분, label: o.세분, price: o[this.step_choose.year], carcode: o.차명코드 } );
          })
        });


      }else if ( idx == 5 ){
        this.nextbtn_text = "확인"
        this.step_choose.caroptions = value.value;
        this.step_choose.price = value.price;
        this.step_choose.id = value.carcode;
        this.step = 5;
      }

    },
    clickClose() {
      this.$store.commit( "SET_DIMMER", false );
      this.status.popup = !this.status.popup;

      this.$emit( 'statusSearchOptions', this.status );
    },
    clickComplete() {
      this.$store.commit( "SET_DIMMER", false );
      var t = true;
      for (const property in this.step_choose) {
        if(!this.step_choose[property] || this.step_choose[property] == ''){
          t = false;
        }
      }
      if(t){
        this.status.popup = !this.status.popup;
        this.$emit( 'statusSearchOptions', this.status );
        this.$emit( 'searchComplete', this.step_choose );
      }
    },
    checkValue: function( value ){
      this.$emit( "checkPopup", value);
    },
    submitQuestion() {
      alert("질문이 전송되었습니다.")
    }
  }
}
</script>
